import React from 'react';

export const MaterialContext = React.createContext({
    material: null,
    setMaterial: (material) => { }
});

const MaterialProvider = ({ children }) => {
    const [material, setMaterial] = React.useState(null);

    return (
        <MaterialContext.Provider value={{ material, setMaterial }}>
            {children}
        </MaterialContext.Provider>
    );
};

export default MaterialProvider;